import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import axios from "axios";
import PageContainer from "../MainPages/PageContainer";
import Breadcrumb from "../MainPages/Breadcrumb";

const TransactionHistory = () => {
    const [transactions, settransactions] = useState()
    const userInfo = JSON.parse(sessionStorage.getItem('user-info'))
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loader, setloader] = useState(false)
    const getData = async (perpage = rowsPerPage, page = currentPage) => {
        setloader(true)
        try {
            const response = await axios.get(`/apiV1/transaction-details/?page_size=${perpage}&page_number=${page}&customer=${userInfo.id}`)
            if (response.status === 200) {
                settransactions(response.data.results)
                setloader(false)
            }
        } catch (err) {
            setloader(false)
            console.log(err);

        }
    }
    useEffect(() => {
        getData()
    }, [])
    const columns = [
        {
            name: "Date",
            selector: (row) => row.payment_date,
            sortable: true,
        }
        ,
        {
            name: "Name",
            selector: (row) => row.customer__fullname,
            sortable: true,
        },
        {
            name: "Transaction ID",
            selector: (row) => row.transaction_id,
            sortable: true,
        },
        {
            name: "Plan Type",
            selector: (row) => row.subscription__plan_type
            ,
            sortable: true,
        },
        {
            name: "Payment Method",
            selector: (row) => row.payment_method,
        },
        {
            name: "Currency",
            selector: (row) => row.currency,
        },
        {
            name: "Amount",
            selector: (row) => row.amount_paid,
        },
        {
            name: "Status",
            selector: (row) => row.payment_status,
            cell: (row) => (
                <Typography
                    sx={{
                        color: row.payment_status === "completed" ? "green" : row.payment_status === "pending" ? "orange" : "red",
                        fontWeight: "bold",
                    }}
                >
                    {row.payment_status}
                </Typography>
            ),
        },
    ];
    const BCrumb = [
        {
            to: '/plans',
            title: 'Plans',
        }
    ];

    const handlePageChange = (page) => {
        setCurrentPage(page);
        console.log("Page changed to:", page);
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
        getData(newRowsPerPage, currentPage)
        console.log("Rows per page changed to:", newRowsPerPage);
    };
    return (
        <>
            <PageContainer title="Auto SDLC | Transactionhistory">
                <Breadcrumb breadcrumbs={BCrumb} />
                <Box sx={{ mt: 3 }}>
                    <Paper sx={{ padding: 3, boxShadow: 3 }}>

                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                            Transaction History
                        </Typography>
                        {loader ? (
                            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={transactions}
                                pagination
                                paginationPerPage={rowsPerPage}
                                highlightOnHover
                                responsive
                                onPageChange={handlePageChange}
                                onChangeRowsPerPage={handleRowsPerPageChange}
                                paginationServer
                                paginationDefaultPage={currentPage}
                            />
                        )}
                    </Paper>
                </Box>
            </PageContainer>
        </>
    );
};

export default TransactionHistory;
